package com.patronat.top.features.dashboard.presentation.model

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter

data class DashboardStatCardUi(
    val id: String,
    val title: String,
    val icon: @Composable () -> Painter,
    val metrics: List<DashboardStatMetricUi>
)

data class DashboardStatMetricUi(
    val label: String,
    val value: String,
    val percentage: String? = null
)
